import { TextField, makeTextFieldClear, makeTextFieldIcon } from 'shared/ui/TextField'
import styles from './styles.module.scss'

type IWidgetSearchProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const WidgetSearch = ({ value, onChange, placeholder = 'Search' }: IWidgetSearchProps) => (
  <TextField
    className={styles.search}
    value={value}
    onChange={onChange}
    variant='integrated'
    InputProps={{ placeholder, className: styles.searchInput }}
    leftActions={[
      makeTextFieldIcon({
        icon: 'search',
        color: 'var(--content-primary-tertiary)',
        fontSize: 16,
      }),
    ]}
    rightActions={[makeTextFieldClear({ isButton: true, isVisibleWithoutFocus: true })]}
  />
)
